import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaSwitch from './VaSwitch.vue'

export default withConfigTransport(VaSwitch)
